
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useScrollToTop() {
  const { pathname, hash } = useLocation();
  
  useEffect(() => {
    // If the URL targets a section (e.g. /services#tonte-de-pelouse),
    // scroll to that section instead of the top of the page.
    if (hash) {
      const timeoutId = setTimeout(() => {
        const element = document.getElementById(hash.slice(1));
        if (element) {
          element.scrollIntoView({ behavior: 'auto', block: 'start' });
          return;
        }
        window.scrollTo(0, 0);
      }, 50);
      return () => clearTimeout(timeoutId);
    }

    // Immediate scroll to ensure the page always starts at the top
    window.scrollTo(0, 0);
    
    // For browsers that support smooth scrolling, provide a smoother experience
    // with a slight delay to ensure it works consistently
    const timeoutId = setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto'
      });
    }, 0);
    
    return () => clearTimeout(timeoutId);
  }, [pathname, hash]);
}

export default useScrollToTop;
